import * as React from 'react';
import {BlogPostsSearchPropType} from '@nls-2022/nls-bll';
import BlogPostsList from './BlogPostsList';
import BlogPostSearchByPublishedFlag from './BlogPostSearchByPublishedFlag';
import BlogPostSearchByPubDate from './BlogPostSearchByPubDate';
import {
  filterByPublishedStatus,
  filterByCategories,
  filterByPubDate,
} from '@nls-2022/nls-bll';
import {FilterType} from '@nls-2022/nls-bll';
import PageList from './PageList';
//<BlogPostsFilter
//        blogPosts={blogPosts}
//        resultContext={resultContext}
//        handleFilteredBlogPostsUpdate={setFilteredBlogPosts}
//        blogPostsDispatch={blogPostsDispatch}
//      />

const BlogPostsSearch = ({
  blogPosts,
  resultType,
  resultContext,
  blogPostsDispatch,
}: BlogPostsSearchPropType) => {
  const [publishedBlogPostsOnly, setPublishedBlogPostsOnly] =
    React.useState(false);
  const [pubDateFrom, setPubDateFrom] = React.useState('2000-01-01');
  const [currentPage, setCurrentPage] = React.useState(1);
  const handlePublishedBlogPostsOnlyFlagChange = (ev: any) => {
    setPublishedBlogPostsOnly(ev.target.checked);
    setCurrentPage(1);
  };
  const handleSearchByPubDateChange = (ev: any) => {
    setPubDateFrom(ev.target.value);
    setCurrentPage(1);
  };
  const handlePageChanged = (ev: any) => {
    setCurrentPage(ev.target.innerText);
  };
  let filteredList = filterByPublishedStatus(
    blogPosts!,
    publishedBlogPostsOnly,
  );
  if (publishedBlogPostsOnly) {
    filteredList = filterByPubDate(filteredList, pubDateFrom, FilterType.GTE);
  }
  //const pagedFilteredList = filteredList!.slice(
  //  (currentPage - 1) * 10 + 1,
  //  currentPage * 10,
  //);
  const pagedFilteredList = filteredList!.slice(
    (currentPage - 1) * 10,
    currentPage * 10,
  );
  return (
    <>
      <h2>Blog Post Search</h2>
      <p>Filter</p>
      <BlogPostSearchByPublishedFlag
        publishedFlag={publishedBlogPostsOnly}
        handlePublishedFlagSearch={handlePublishedBlogPostsOnlyFlagChange}
      >
        <p>published flag</p>
      </BlogPostSearchByPublishedFlag>
      {publishedBlogPostsOnly ? (
        <BlogPostSearchByPubDate
          pubDate={pubDateFrom}
          filterBy={FilterType.GT}
          handlePubDateSearch={handleSearchByPubDateChange}
        >
          <p>published date</p>
        </BlogPostSearchByPubDate>
      ) : (
        <></>
      )}
      <PageList
        noOfItems={filteredList.length}
        pageSize={11}
        handlePageChange={handlePageChanged}
      />
      <p>Filter Results</p>
      <BlogPostsList
        blogPosts={pagedFilteredList!}
        resultContext={resultContext}
        blogPostsDispatch={blogPostsDispatch}
      />
    </>
  );
};

export default BlogPostsSearch;
